export const VEHICLE = [
    {id: 1, label: "Car", value: "Car", logoColorless: "/images/car-colorless.png", logoColor: "/images/car-color.png"},
    // {id: 2, label: "Van", value: "Van", logoColorless: "/images/van-colorless.png", logoColor: "/images/van-color.png"},
    {id: 2, label: "Flat Roof Van", value: "Flat Roof Van", logoColorless: "/images/van-colorless.png", logoColor: "/images/van-color.png"},
    {id: 3, label: "High Roof Van", value: "High Roof Van", logoColorless: "/images/highroof-van-colorless.png", logoColor: "/images/highroof-van-color.png"},
    // {id: 4, label: "Mini Couch", value: "Mini Couch", logoColorless: "/images/Jeep.png", logoColor: "/images/jeep-color.png"}
]

export const CALCULATOR_TAGS = {
    USD_CONVERSION: "USD_CONVERSION",
    KM_LESS_EQUAL_7: "KM_LESS_EQUAL_7",
    KM_GREATER_7: "KM_GREATER_7",
    BATTA: "BATTA",
    MIN_KM_PER_DAY: "MIN_KM_PER_DAY"
}

export const MONTH = [
    {id: 0, label: "January", value: "January", season: "Peak"},
    {id: 1, label: "February", value: "February", season: "Peak"},
    {id: 2, label: "March", value: "March", season: "Peak"},
    {id: 3, label: "April", value: "April", season: "Peak"},
    {id: 4, label: "May", value: "May", season: "Off"},
    {id: 5, label: "June", value: "June", season: "Off"},
    {id: 6, label: "July", value: "July", season: "Peak"},
    {id: 7, label: "August", value: "August", season: "Peak"},
    {id: 8, label: "September", value: "September", season: "Off"},
    {id: 9, label: "October", value: "October", season: "Off"},
    {id: 10, label: "November", value: "November", season: "Peak"},
    {id: 11, label: "December", value: "December", season: "Peak"}
]

export const MARGIN = [
    // Car
    {
        vehicle: 1,
        breakdown: [
            {
                minDay: 0, 
                maxDay: 4,
                seasonal_rate: {
                    peak: 0,
                    off: 0
                }
            },
            {
                minDay: 5, 
                maxDay: 6,
                seasonal_rate: {
                    peak: 90,
                    off: 80
                }
            },
            {
                minDay: 7, 
                maxDay: 8,
                seasonal_rate: {
                    peak: 100,
                    off: 80
                }
            },
            {
                minDay: 9, 
                maxDay: 10,
                seasonal_rate: {
                    peak: 130,
                    off: 100
                }
            },
            {
                minDay: 11, 
                maxDay: 12,
                seasonal_rate: {
                    peak: 140,
                    off: 120
                }
            },
            {
                minDay: 13, 
                maxDay: 14,
                seasonal_rate: {
                    peak: 150,
                    off: 140
                }
            },
            {
                minDay: 15, 
                maxDay: Infinity,
                seasonal_rate: {
                    peak: 150,
                    off: 140
                }
            }
        ]
    },
    // Flat Roof Van
    {
        vehicle: 2,
        breakdown: [
            {
                minDay: 0, 
                maxDay: 4,
                seasonal_rate: {
                    peak: 0,
                    off: 0
                }
            },
            {
                minDay: 5, 
                maxDay: 6,
                seasonal_rate: {
                    peak: 135,
                    off: 120
                }
            },
            {
                minDay: 7, 
                maxDay: 8,
                seasonal_rate: {
                    peak: 150,
                    off: 140
                }
            },
            {
                minDay: 9, 
                maxDay: 10,
                seasonal_rate: {
                    peak: 180,
                    off: 160
                }
            },
            {
                minDay: 11, 
                maxDay: 12,
                seasonal_rate: {
                    peak: 220,
                    off: 160
                }
            },
            {
                minDay: 13, 
                maxDay: 14,
                seasonal_rate: {
                    peak: 260,
                    off: 180
                }
            },
            {
                minDay: 15, 
                maxDay: Infinity,
                seasonal_rate: {
                    peak: 290,
                    off: 200
                }
            }
        ]
    },
    // High Roof Van
    {
        vehicle: 3,
        breakdown: [
            {
                minDay: 0, 
                maxDay: 4,
                seasonal_rate: {
                    peak: 0,
                    off: 0
                }
            },
            {
                minDay: 5, 
                maxDay: 6,
                seasonal_rate: {
                    peak: 150,
                    off: 150
                }
            },
            {
                minDay: 7, 
                maxDay: 8,
                seasonal_rate: {
                    peak: 165,
                    off: 150
                }
            },
            {
                minDay: 9, 
                maxDay: 10,
                seasonal_rate: {
                    peak: 220,
                    off: 180
                }
            },
            {
                minDay: 11, 
                maxDay: 12,
                seasonal_rate: {
                    peak: 250,
                    off: 200
                }
            },
            {
                minDay: 13, 
                maxDay: 14,
                seasonal_rate: {
                    peak: 290,
                    off: 200
                }
            },
            {
                minDay: 15, 
                maxDay: Infinity,
                seasonal_rate: {
                    peak: 330,
                    off: 200
                }
            }
        ]
    }
]